import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { BeforeAfter } from './components/BeforeAfter';
import { PainPoints } from './components/PainPoints';
import { Volumes } from './components/Volumes';
import { Library } from './components/Library';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Author } from './components/Author';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-white text-ink" data-id="element-0" data-mp="28suv0pbgc1ms">
      <MetaPixel data-id="element-1" data-mp="23u9vyt7xrnzx" />
      <Hero data-id="element-2" data-mp="23utadzydnu97" />
      <main data-id="element-3" data-mp="23t8i6gzjcnei">
        <BeforeAfter data-id="element-4" data-mp="23ti67z10skhk" />
        <PainPoints data-id="element-5" data-mp="3ikh8ubu2yx01" />
        <Volumes data-id="element-6" data-mp="3iiwf2oflbi38" />
        <Library data-id="element-7" data-mp="3ijfv1zlojwem" />
        <Bonuses data-id="element-8" data-mp="3ihv048vgebg8" />
        <Offer data-id="element-9" data-mp="3mlj8gtrwtb2j" />
        <Guarantee data-id="element-10" data-mp="3ml1419v3fqjj" />
        <Testimonials data-id="element-11" data-mp="3mkhn9wh6j873" />
        <Author data-id="element-12" data-mp="3mjzpgvevclx2" />
        <FAQ data-id="element-13" data-mp="3mjgczu7zmpqf" />
        <FinalCTA data-id="element-14" data-mp="3rc9d24sih9w6" />
      </main>
      <Footer data-id="element-15" data-mp="3rbzngibdp4r0" />
      <FloatingCTA data-id="element-16" data-mp="3rdkgg3i1ofmr" />
      <PurchasePopup data-id="element-17" data-mp="3rd191gq0t9mz" />
    </div>;
}